import { Component, Input, OnInit } from '@angular/core';
import { ItemDataService } from '../../services/item-data.service';
import { BaseComponent } from '../base.component';
import { TieredEquipment } from '../../models/item-data-models';

@Component({
  selector: 'app-equipment-label',
  templateUrl: './equipment-label.component.html',
  styleUrls: ['../label-common.scss', './equipment-label.component.scss']
})
export class EquipmentLabelComponent extends BaseComponent implements OnInit {
  @Input({ required: true }) equipment!: TieredEquipment;
  @Input() hideTooltip?: boolean;
  @Input() displayLabel?: string;
  @Input() hiddenByQuickFilter?: boolean;
  @Input() manualTier?: boolean;
  @Input() icon?: string;

  public colorClass: string = '';

  constructor(private itemDataService: ItemDataService) {
    super();
  }

  ngOnInit(): void {
    this.calculateIcon();
    this.calculateColor();
  }

  private calculateIcon(): void {
    if (this.icon) {
      return;
    }

    // Calculate icon based on slot and selection
    switch (this.equipment.slot) {
      case 'gear':
        if (this.equipment.selection === 'my') {
          this.icon = this.poe1
            ? '/img/gear/weapons/twohandweapons/bows/bow1.webp'
            : '/img/gear/weapons/twohandweapons/bows/bow01.webp';
        } else {
          this.icon = this.poe1
            ? '/img/gear/weapons/twohandweapons/bows/bow2.webp'
            : '/img/gear/weapons/twohandweapons/crossbows/2hcrossbow01.webp';
        }
        break;
      case 'jewellery':
        if (this.equipment.selection === 'my') {
          this.icon = this.poe1
            ? '/img/gear/amulets/amulet6.webp'
            : '/img/gear/amulets/goldamulet.webp';
        } else {
          this.icon = this.poe1
            ? '/img/gear/amulets/rubyamulet.webp'
            : '/img/gear/amulets/crimsonamulet.webp';
        }
        break;
      case 'jewel':
        if (this.equipment.selection === 'my') {
          this.icon = this.poe1
            ? '/img/gear/jewels/basicdex.webp'
            : '/img/gear/jewels/emeraldjewel.webp';
        } else {
          this.icon = this.poe1
            ? '/img/gear/jewels/basicstr.webp'
            : '/img/gear/jewels/rubyjewel.webp';
        }
        break;
      case 'flask':
        if (this.equipment.selection === 'my') {
          this.icon = this.poe1
            ? '/img/gear/flasks/lifeflask11.webp'
            : '/img/gear/flasks/flasklife09.webp';
        } else {
          this.icon = this.poe1
            ? '/img/gear/flasks/lifeflask10.webp'
            : '/img/gear/flasks/flasklife08.webp';
        }
        break;
      case 'charm':
        if (this.equipment.selection === 'my') {
          this.icon = '/img/gear/charms/goldencharm.webp';
        } else {
          this.icon = '/img/gear/charms/groundingcharm.webp';
        }
        break;
      default:
        this.icon = this.poe1
          ? '/img/gear/weapons/twohandweapons/bows/bow1.webp'
          : '/img/gear/weapons/twohandweapons/bows/bow01.webp';
    }
  }

  private calculateColor(): void {
    if (this.equipment.selection === 'gems') {
      this.colorClass = 'gem-color';
    } else if (this.equipment.category === 'rare' || this.equipment.category === 'identified' || this.equipment.displayName.includes('Rare')) {
      this.colorClass = 'rare-item-color';
    } else if (this.equipment.category === 'magic' || this.equipment.displayName.includes('Magic')) {
      this.colorClass = 'magic-item-color';
    } else if (this.equipment.displayName === 'Normal Gold Stacks' || this.equipment.displayName === 'Large Gold Stacks' || this.equipment.displayName === 'Huge Gold Stacks') {
      this.colorClass = 'gold-color';
    } else if (this.equipment.displayName === 'Rogue\'s Markers') {
      this.colorClass = 'currency-color';
    } else {
      this.colorClass = 'normal-item-color';
    }
  }
}
